import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { numberUnmask } from 'utils/unmasks';
import Button from '../../../components/Button';
import Header from '../../../components/Header';
import Validator from '../../../components/Validator';
import imgDeclined from '../../../assets/images/declined.svg';
import schema from './schema';
import Input from '../../../components/Form/Input';
import Progress from '../../../components/Progress';
import ApplicationId from '../../../components/ApplicationId';
import {
  newNextAction,
  NEW_NEXT,
} from '../../../actions/navigation';
import { useConfig } from '../../../config/ConfigContext';

const RepromptSSN = (props) => {
  const config = useConfig();
  const { navigate, params, searchParams, checkinData, validator: { values, errors } } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(false);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');
  const test = searchParams.get('test');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      if (test) {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}&test=${test}`);
      } else {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
      }
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(routeUrl);
    }
  }, [checkinData]);

  const handleSubmitFrom = (e) => {
    e.preventDefault();
    const { dispatch } = props;

    setIsProgressVisible(true);

    if (test) {
      dispatch(newNextAction({
        key,
        workflowType: workflowType || 'text2apply',
        data: {
          test,
          ssn: numberUnmask(values.ssn),
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    } else {
      dispatch(newNextAction({
        key,
        workflowType: workflowType || 'text2apply',
        data: {
          test,
          ssn: numberUnmask(values.ssn),
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    }
  };

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <div className="content">
        <img src={imgDeclined} alt="" />
        <h1 style={{ margin: 0 }}>We had a difficult time verifying you</h1>
        <div className="container">
          <div className="row">
            <div className="col">
              <h3 style={{ marginBottom: 20 }}>Please Re-enter Your Social Security Number</h3>
              <div className="form-group">
                <Input
                  label="9-Digit SSN"
                  value={values.ssn || ''}
                  name="ssn"
                  tooltip="We were unable to completely verify your identity. For this reason please enter your full 9-digit Social Security Number."
                  type="tel"
                  isMasked={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                  onChange={handleInputChange}
                  isRequired
                  hasError={errors.ssn}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <Button
              className="btn btn-primary arrow"
              title="Submit"
              onClick={handleSubmitFrom.bind(null)}
            />
          </div>
        </div>
      </div>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

RepromptSSN.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(RepromptSSN));
